var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "form-file",
      class: ["form-file", { "form-file--invalid": _vm.invalid }]
    },
    [
      _c("input", {
        ref: "file",
        staticClass: "form-file__input",
        attrs: {
          multiple: "",
          type: "file",
          name: _vm.name,
          required: _vm.required
        },
        on: { change: _vm.onChange }
      }),
      _vm.fileNames.length
        ? _c("span", { staticClass: "form-file__label" }, [
            _vm._v(_vm._s(_vm.fileNames.join(", ")))
          ])
        : _c("span", {
            staticClass: "form-file__label",
            domProps: { innerHTML: _vm._s(_vm.label) }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ba88cbb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba88cbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormFile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0ba88cbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormFile.vue
// module chunks = 0 1 2